//MapContextMenu.js
import React, { useEffect, useState, useRef } from 'react';
import useItemsService from '../hooks/useItemsService';
import { useProjectMapContext } from '../hooks/useProjectMapContext';
import { PiTreeBold, PiInfo, PiTrashThin, PiLock } from "react-icons/pi";
import { useSelector } from 'react-redux';
import { debug } from 'utils';
import ProjectIcons from '../helpers/ProjectIcons';
import Indicator from './../items/forms/trees/helpers/Indicator';
import TreePrint from '../items/forms/trees/helpers/TreePrint';
const ItemContextMenu = ({ options = {}, onClick }) => {
  const ref = useRef();
  const [item, setItem] = useState({})
  const project = useSelector(state => state.project);
  const { handleItemMenuClick } = useItemsService();
  const { userCan, } = useProjectMapContext();
  useEffect(() => {

    setItem(options.item)
  }, [options])
  return (
    <div id="ItemContextMenu" className={`contextMenu`} style={{ left: options.left, top: options.top }} ref={ref}>
      <div className={`header d-flex justify-content-between pe-2 pointer`}>
        <div className='main'>
          <ProjectIcons type={item.itType} size={20} className='me-1' />
          {item.itRef}
        </div>
        <span onClick={e => handleItemMenuClick('close')}>&times;</span>
      </div>
      <div className='body'>
        <ul>
          {(project && userCan('editItem')
            // 2025-02-22 les sujets des alignements doivent pouvoir etre déplacés
            // voir pour modifier la ligne d'aligement en ajoutant un point pivot ?
            // && item.itFeatures?.constrained != true 
            && item.itType != 'alignment'
            && item.itType != 'woodarea'
          ) &&
            <li className='pointer' onClick={e => handleItemMenuClick('unlock')} ><span className='me-2'><PiLock /></span>
              {item.unlocked ? 'Verrouiller' : 'Déverrouiller'}
            </li>

          }

          <li className='pointer' onClick={e => handleItemMenuClick('edit')} ><span className='me-2'><PiInfo /></span>Informations</li>
          {item.itType == 'tree' &&
            <li className='pointer'><TreePrint item={item} disabled="false" iconSize={14} label="Imprimer en PDF" btnClassName='' /></li>
          }
          {(project && userCan('editItem')) &&
            <li className='pointer' onClick={e => handleItemMenuClick('delete')} ><span className='me-2'><PiTrashThin /></span>Supprimer</li>
          }
        </ul>
        {item.itType == 'tree' &&
          <div className='mt-3 d-flex justify-content-center'>
            <div className='diag_label '>
              <Indicator
                type="physiologie"
                value={item?.meta?.[`physiology/score/letter`]}
                labelKey="Etat physiologique"
              />
            </div>
            <div className='diag_label px-3'>
              <Indicator
                type="mecanique"
                value={item?.meta?.[`diags/tree/1/mecanique/letter`]}
                labelKey="Risque mécanique"
              />
            </div>
            <div className='diag_label'>
              <Indicator
                type="risque"
                value={item?.meta?.[`diags/tree/1/risque/letter`]}
                labelKey="Niveau de risque"
              />
            </div>
          </div>
        }
      </div>
      <div className='footer'>
      </div>
    </div >
  );
};
export default ItemContextMenu;
